module.exports = __webpack_public_path__ + "5f0b3bd731a9bdce6115a04f9d67ff7a.png";